module.exports = __webpack_public_path__ + "static/media/maintenance.7eb0135c.jpg";